const easeInOutQuad = (t, b, c, d) => {
  t /= d / 2;
  if (t < 1) return (c / 2) * t * t + b;
  t--;
  return (-c / 2) * (t * (t - 2) - 1) + b;
};

export const scrollToWithAnimation = (
  element,
  to = 0,
  duration = 300,
  onScrollEndCallback = () => {}
) => {
  const properElement = element ?? {};
  const start = properElement.scrollTop ?? 0;
  const change = to - start;
  let currentTime = 0;
  const increment = 20;
  const animateScroll = () => {
    currentTime += increment;
    const val = easeInOutQuad(currentTime, start, change, duration);
    properElement.scrollTop = val;
    if (currentTime < duration) {
      setTimeout(animateScroll, increment);
    } else {
      onScrollEndCallback?.();
    }
  };

  animateScroll();
};
